import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { BookSeries } from 'bookraw/shared/models/book-series.model';


@Injectable()
export class BookSeriesService extends ListService<BookSeries> {
  url: string = '/api/admin/bookLists';
}
